var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright ml-auto"},[_vm._v("\n                2019, made with "),_c('i',{staticClass:"fa fa-heart heart text-danger"}),_vm._v(" by "),_c('a',{attrs:{"href":""}},[_vm._v("Diskominfo-Sandi Kab. Konsel")])])])])])
}]

export { render, staticRenderFns }